<template>
    <span class="relative inline-flex h-6 w-6 flex-none items-center justify-center" aria-hidden="true">
        <font-awesome-icon :icon="faBookmark" class="h-full w-full text-[#7293cb]" />
        <!-- Nudged above centre because the bookmark's notched foot puts its visual
             centre higher than its bounding box centre. -->
        <font-awesome-icon :icon="faStar" class="absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-[65%] text-white" />
    </span>
</template>

<script setup>
// The RiskGuard Pro emblem on the pricing cards (RAC-10438): a bookmark with a star
// set into it. FontAwesome Pro has no single icon for this, so it is composed from
// faBookmark + faStar. Stacked with Tailwind positioning rather than <font-awesome-layers>
// because the fa-layers CSS from fontawesome-svg-core is not loaded in this app.
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBookmark, faStar } from '@fortawesome/pro-solid-svg-icons'
</script>
